/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProfileProperty {
    BIRTH_DATE = 'BirthDate',
    LOCATION = 'Location',
    FAVOURITE_FESTIVAL = 'FavouriteFestival',
    REGION = 'Region',
    SOCIAL_MEDIA = 'SocialMedia',
    GENRE = 'Genre',
    GENDER = 'Gender',
}
